export enum SignFormFields {
  Signature = 'signature',
  Name = 'name',
  Initials = 'initials',
  Date = 'date',
}
